/* Sivasti storefront - shared behaviour for the home sections (prefix: svs-) */
(function () {
  if (window.__svsShop) return;
  window.__svsShop = true;

  const doc = document;
  const $ = (s, r) => (r || doc).querySelector(s);
  const $$ = (s, r) => Array.prototype.slice.call((r || doc).querySelectorAll(s));
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const BAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l-1 13H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  const TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* ---------- money (uses the store's own money format) ---------- */
  const moneyFormat = () => {
    const el = $('[data-svs-money]');
    return (el && el.getAttribute('data-svs-money')) || '${{amount}}';
  };
  const num = (v, dec, thou, dot) => {
    const p = v.toFixed(dec).split('.');
    p[0] = p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
    return p.join(dot);
  };
  const money = (cents) => {
    const v = cents / 100;
    return moneyFormat().replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case 'amount_no_decimals': return num(v, 0, ',', '.');
        case 'amount_with_comma_separator': return num(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(v, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return num(v, 0, ' ', '.');
        case 'amount_with_space_separator': return num(v, 2, ' ', ',');
        default: return num(v, 2, ',', '.');
      }
    });
  };
  const toCents = (s) => Math.round(parseFloat(s) * 100);

  /* ---------- cart ---------- */
  const setCount = (n) => {
    if (typeof window.svSetCartCount === 'function') { window.svSetCartCount(n); return; }
    $$('[data-svh-count]').forEach((el) => { el.textContent = n; el.hidden = n < 1; });
  };
  const refreshCart = () => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
    .then((r) => r.json()).then((c) => { setCount(c.item_count); return c; }).catch(() => null);
  const addToCart = (id) => fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
  }).then((r) => r.json().then((j) => {
    if (!r.ok) throw new Error(j.description || j.message || 'Could not add this item');
    return j;
  }));

  /* ---------- toast ---------- */
  let toastEl, toastTimer;
  const toast = (msg, ok) => {
    if (!toastEl) {
      toastEl = doc.createElement('div');
      toastEl.className = 'svs svs-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      doc.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-bad', ok === false);
    toastEl.innerHTML = '<span>' + esc(msg) + '</span>' + (ok === false ? '' : '<a href="' + root + 'cart">View bag</a>');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-show'), 3400);
  };

  const done = () => refreshCart().then(() => { if (typeof window.svBumpCart === 'function') window.svBumpCart(); });

  /* ---------- quick add: bag button on every card ---------- */
  const quickAdd = (btn, vid) => {
    btn.classList.add('is-busy');
    addToCart(vid).then(() => {
      btn.classList.remove('is-busy');
      btn.classList.add('is-done');
      btn.innerHTML = TICK;
      setTimeout(() => { btn.classList.remove('is-done'); btn.innerHTML = BAG; }, 1500);
      toast('Added to your bag');
      done();
    }).catch((err) => {
      btn.classList.remove('is-busy');
      toast(err.message, false);
    });
  };

  let dlg;
  const buildDialog = () => {
    dlg = doc.createElement('dialog');
    dlg.className = 'svs svs-qa';
    dlg.setAttribute('aria-label', 'Choose options');
    dlg.innerHTML = '<button type="button" class="svs-qa-x" aria-label="Close">&times;</button>' +
      '<div class="svs-qa-in"><div class="svs-qa-pic"><img alt=""></div><div><p class="svs-qa-title"></p>' +
      '<p class="svs-qa-price"><span class="svs-now"></span><s class="svs-was"></s></p></div></div>' +
      '<div class="svs-qa-opts"></div><p class="svs-qa-err" role="alert" hidden></p>' +
      '<button type="button" class="svs-qa-add">Add to bag</button>';
    doc.body.appendChild(dlg);
    $('.svs-qa-x', dlg).addEventListener('click', () => closeDlg());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) closeDlg(); });
  };
  const closeDlg = () => { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); };
  const openDlg = () => { if (dlg.showModal) { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', ''); };

  const openPicker = (handle, trigger) => {
    if (!dlg) buildDialog();
    if (trigger) trigger.classList.add('is-busy');
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => { if (!r.ok) throw new Error('Product not found'); return r.json(); })
      .then((p) => {
        if (trigger) trigger.classList.remove('is-busy');
        renderPicker(p);
        openDlg();
      }).catch((err) => { if (trigger) trigger.classList.remove('is-busy'); toast(err.message, false); });
  };

  const renderPicker = (p) => {
    const vs = p.variants || [];
    const names = (p.options || []).map((o) => (typeof o === 'string' ? o : o.name));
    const vals = names.map((n, i) => vs.reduce((a, v) => { const x = v['option' + (i + 1)]; if (x != null && a.indexOf(x) < 0) a.push(x); return a; }, []));
    const first = vs.filter((v) => v.available)[0] || vs[0];
    const sel = names.map((n, i) => first['option' + (i + 1)]);
    const img = $('.svs-qa-pic img', dlg), title = $('.svs-qa-title', dlg), now = $('.svs-now', dlg), was = $('.svs-was', dlg);
    const optsEl = $('.svs-qa-opts', dlg), err = $('.svs-qa-err', dlg), add = $('.svs-qa-add', dlg);
    title.textContent = p.title;
    err.hidden = true;
    const current = () => vs.filter((v) => names.every((n, i) => v['option' + (i + 1)] === sel[i]))[0];
    const okWith = (i, val) => vs.some((v) => v.available && v['option' + (i + 1)] === val && names.every((n, j) => j === i || v['option' + (j + 1)] === sel[j]));
    const paint = () => {
      const v = current();
      const src = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
      if (src) { img.src = src.replace(/(\.[a-z0-9]+)(\?.*)?$/i, '_360x$1$2'); }
      if (v) {
        now.textContent = money(v.price);
        now.className = 'svs-now' + (v.compare_at_price > v.price ? ' is-sale' : '');
        was.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        add.disabled = !v.available;
        add.textContent = v.available ? 'Add to bag' : 'Sold out';
      } else { add.disabled = true; add.textContent = 'Unavailable'; }
      $$('.svs-opt', optsEl).forEach((fs, i) => {
        $('legend span', fs).textContent = sel[i];
        $$('.svs-val', fs).forEach((b) => {
          const val = b.getAttribute('data-v');
          b.classList.toggle('is-on', val === sel[i]);
          b.classList.toggle('is-out', !okWith(i, val));
          b.setAttribute('aria-pressed', val === sel[i] ? 'true' : 'false');
        });
      });
    };
    optsEl.innerHTML = names.length === 1 && names[0] === 'Title' ? '' : names.map((n, i) =>
      '<fieldset class="svs-opt"><legend>' + esc(n) + ': <span></span></legend><div class="svs-opt-vals">' +
      vals[i].map((v) => '<button type="button" class="svs-val" data-v="' + esc(v) + '">' + esc(v) + '</button>').join('') +
      '</div></fieldset>').join('');
    optsEl.onclick = (e) => {
      const b = e.target.closest('.svs-val'); if (!b) return;
      const fs = b.closest('.svs-opt');
      sel[$$('.svs-opt', optsEl).indexOf(fs)] = b.getAttribute('data-v');
      paint();
    };
    add.onclick = () => {
      const v = current(); if (!v || !v.available) return;
      add.disabled = true; add.textContent = 'Adding...';
      addToCart(v.id).then(() => { closeDlg(); toast('Added to your bag'); done(); })
        .catch((e) => { err.textContent = e.message; err.hidden = false; add.disabled = false; add.textContent = 'Add to bag'; });
    };
    paint();
  };

  doc.addEventListener('click', (e) => {
    const b = e.target.closest('[data-svs-quick]');
    if (!b) return;
    e.preventDefault();
    const vid = b.getAttribute('data-vid');
    if (vid) quickAdd(b, vid); else openPicker(b.getAttribute('data-svs-quick'), b);
  });

  /* ---------- hero slider ---------- */
  const initSlider = (el) => {
    if (el.__svs) return; el.__svs = 1;
    const track = $('.svs-track', el), slides = $$('.svs-slide', el), dots = $$('.svs-dot', el);
    const prev = $('[data-prev]', el), next = $('[data-next]', el);
    const n = slides.length, secs = parseFloat(el.getAttribute('data-auto')) || 0;
    let idx = 0, timer = null;
    const go = (i) => { idx = (i + n) % n; track.scrollTo({ left: idx * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
    const sync = () => {
      const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      idx = i;
      dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => { if (!secs || n < 2 || reduce || timer) return; timer = setInterval(() => { if (!doc.hidden) go(idx + 1); }, secs * 1000); };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); stop(); start(); }));
    if (prev) prev.addEventListener('click', () => { go(idx - 1); stop(); start(); });
    if (next) next.addEventListener('click', () => { go(idx + 1); stop(); start(); });
    el.addEventListener('mouseenter', stop); el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop); el.addEventListener('focusout', start);
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', () => setTimeout(start, 4000), { passive: true });
    window.addEventListener('resize', () => { track.scrollLeft = idx * track.clientWidth; });
    if ('IntersectionObserver' in window) new IntersectionObserver((es) => { es[0].isIntersecting ? start() : stop(); }).observe(el); else start();
    sync();
  };

  /* ---------- category circles -> picture tray ---------- */
  const initCats = (sec) => {
    if (sec.__svs) return; sec.__svs = 1;
    const btns = $$('button.svs-circle', sec), tray = $('.svs-tray', sec), panes = $$('.svs-pane', sec);
    btns.forEach((b, i) => b.addEventListener('click', () => {
      const wasOpen = b.getAttribute('aria-expanded') === 'true';
      btns.forEach((x, k) => x.setAttribute('aria-expanded', k === i && !wasOpen ? 'true' : 'false'));
      panes.forEach((p, k) => { p.hidden = !(k === i && !wasOpen); });
      tray.classList.toggle('is-open', !wasOpen);
    }));
  };

  /* ---------- countdown (only when the merchant set a real end date) ---------- */
  const initTimer = (el) => {
    if (el.__svs) return; el.__svs = 1;
    const end = Date.parse(el.getAttribute('data-svs-countdown'));
    if (isNaN(end)) { el.hidden = true; return; }
    const set = (k, v) => { const t = $('[data-' + k + ']', el); if (t) t.textContent = String(v).padStart(2, '0'); };
    const dayEl = $('[data-dd]', el);
    const tick = () => {
      const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (s <= 0) { el.hidden = true; clearInterval(iv); return; }
      el.hidden = false;
      const d = Math.floor(s / 86400);
      if (dayEl) { dayEl.hidden = d < 1; dayEl.textContent = d + 'd'; }
      set('hh', Math.floor((s % 86400) / 3600)); set('mm', Math.floor((s % 3600) / 60)); set('ss', s % 60);
    };
    const iv = setInterval(tick, 1000);
    tick();
  };

  /* ---------- "For you" grid: tabs + load more (collection JSON) ---------- */
  const sized = (src, w) => src.replace(/(\.[a-z0-9]+)(\?.*)?$/i, '_' + w + 'x$1$2');
  const cardHTML = (p) => {
    const vs = p.variants || [], imgs = p.images || [];
    const avail = vs.filter((v) => v.available);
    const pool = avail.length ? avail : vs;
    const best = pool.reduce((a, b) => (toCents(b.price) < toCents(a.price) ? b : a), pool[0] || { price: '0' });
    const price = toCents(best.price), cmp = best.compare_at_price ? toCents(best.compare_at_price) : 0;
    const sale = cmp > price, off = sale ? Math.round((cmp - price) * 100 / cmp) : 0;
    const url = root + 'products/' + p.handle;
    const pic = (im, cls) => im ? '<img class="' + cls + '" src="' + esc(sized(im.src, 480)) + '" srcset="' +
      [240, 360, 480, 640].map((w) => esc(sized(im.src, w)) + ' ' + w + 'w').join(', ') +
      '" sizes="(max-width:767px) 50vw, (max-width:1199px) 25vw, 20vw" alt="" loading="lazy">' : '';
    return '<li class="svs-card"><div class="svs-imgwrap"><a class="svs-card-media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
      pic(imgs[0], 'svs-card-main') + pic(imgs[1], 'svs-card-alt') + '</a>' +
      (!avail.length ? '<span class="svs-badge svs-badge--out">Sold out</span>' : sale ? '<span class="svs-badge">-' + off + '%</span>' : '') +
      (avail.length ? '<button type="button" class="svs-bag" data-svs-quick="' + esc(p.handle) + '"' + (vs.length === 1 ? ' data-vid="' + vs[0].id + '"' : '') + ' aria-label="Add to bag: ' + esc(p.title) + '">' + BAG + '</button>' : '') +
      '</div><div class="svs-info"><a class="svs-title" href="' + url + '">' + esc(p.title) + '</a><p class="svs-price"><span class="svs-now' +
      (sale ? ' is-sale' : '') + '">' + money(price) + '</span>' + (sale ? '<s class="svs-was">' + money(cmp) + '</s>' : '') + '</p></div></li>';
  };

  const initFy = (sec) => {
    if (sec.__svs) return; sec.__svs = 1;
    const grid = $('.svs-grid', sec), more = $('.svs-more', sec), btn = $('.svs-more-btn', sec), note = $('.svs-more-note', sec);
    const chips = $$('.svs-chip', sec);
    const per = parseInt(sec.getAttribute('data-per'), 10) || 12;
    let cur = sec.getAttribute('data-handle') || '';
    const cache = {};
    const st = { page: 1, done: sec.getAttribute('data-more') !== 'true', token: 0 };
    const ui = () => { if (more) more.hidden = st.done; if (note) note.textContent = 'Showing ' + $$('.svs-card', grid).length + ' products'; };
    const fetchPage = (handle, page, reset) => {
      const token = ++st.token;
      grid.classList.add('is-loading');
      btn.disabled = true;
      return fetch(root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=' + per + '&page=' + page, { headers: { Accept: 'application/json' } })
        .then((r) => { if (!r.ok) throw new Error('x'); return r.json(); })
        .then((d) => {
          if (token !== st.token) return;
          const list = d.products || [];
          if (reset) grid.innerHTML = '';
          grid.insertAdjacentHTML('beforeend', list.map(cardHTML).join(''));
          if (reset && !list.length) grid.innerHTML = '<li class="svs-empty">No products here yet.</li>';
          st.page = page; st.done = list.length < per;
        })
        .catch(() => { if (token === st.token && reset) grid.innerHTML = '<li class="svs-empty">Could not load products. Please try again.</li>'; })
        .then(() => { if (token !== st.token) return; grid.classList.remove('is-loading'); btn.disabled = false; ui(); });
    };
    btn.addEventListener('click', () => fetchPage(cur, st.page + 1, false));
    chips.forEach((chip) => chip.addEventListener('click', () => {
      const h = chip.getAttribute('data-handle');
      if (h === cur) return;
      cache[cur] = { html: grid.innerHTML, page: st.page, done: st.done };
      chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
      cur = h; st.token++;
      if (cache[h]) { grid.innerHTML = cache[h].html; st.page = cache[h].page; st.done = cache[h].done; grid.classList.remove('is-loading'); btn.disabled = false; ui(); return; }
      fetchPage(h, 1, true);
    }));
    ui();
  };

  const initAll = (scope) => {
    const r = scope || doc;
    $$('[data-svs-slider]', r).forEach(initSlider);
    $$('[data-svs-cats]', r).forEach(initCats);
    $$('[data-svs-countdown]', r).forEach(initTimer);
    $$('[data-svs-fy]', r).forEach(initFy);
  };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  doc.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
